import Vue from 'vue'

// 日期转换
Vue.filter('formatterDate', (str, pattern) => {
  if (!str) {
    return null
  }
  let date = new Date(str)
  if (Object.prototype.toString.call(date) === '[object Date]') {
    // it is date
    if (isNaN(date.getTime())) {
      // invalid
      console.warn('Formatter: invalid date')
      return ''
    }
    pattern = pattern || 'YYYY-MM-DD'
    const o = {
      'M+': date.getMonth() + 1, // 月份
      'D+': date.getDate(), // 日
      'd+': date.getDate(), // 日
      'H+': date.getHours(), // 小时
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'Q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      'S': date.getMilliseconds() // 毫秒
    }
    if (/(y+)/i.test(pattern)) {
      pattern = pattern.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    if (/(W+)/i.test(pattern)) { // 周
      const weekDay = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
      const w = date.getDay()
      pattern = pattern.replace(RegExp.$1, weekDay[w])
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(pattern)) pattern = pattern.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
    return pattern
  }
  console.warn('Formatter: invalid date')
  return ''
})

/**
 * 格式化时间（时间戳转日期）
 * @param time 时间戳(毫秒)
 * @returns {string} 日期（格式： 2017-09-20 年月日）
 */
export function formatDateYmd (time) {
  let createTime = new Date()
  createTime.setTime(time)
  let year = createTime.getFullYear()
  let month = createTime.getMonth() + 1 < 10 ? `0${createTime.getMonth() + 1}` : createTime.getMonth() + 1
  let day = createTime.getDate() < 10 ? `0${createTime.getDate()}` : createTime.getDate()
  return `${year}-${month}-${day}`
}

/**
 * 格式化时间（时间戳转日期）
 * @param time 时间戳(毫秒)
 * @returns {string} 日期（格式： 10:20:20 是分秒）
 */
export function formatDateHm (time) {
  let createTime = new Date()
  createTime.setTime(time)
  let hour = createTime.getHours() < 10 ? `0${createTime.getHours()}` : createTime.getHours()
  let minute = createTime.getMinutes() < 10 ? `0${createTime.getMinutes()}` : createTime.getMinutes()
  let seconds = createTime.getSeconds() < 10 ? `0${createTime.getSeconds()}` : createTime.getSeconds()
  return `${hour}:${minute}:${seconds}`
}

// 实现手机号码中间4位用星号（*）替换显示
Vue.filter('hidtel', ($phone) => {
  const $IsWhat = /0\d{2,3}-\d{7,8}/.test($phone)// 固定电话
  // 固定电话
  if ($IsWhat) {
    return $phone.replace(/(0\d{2,3}-)\d{4}(\d{3,4})/, '$1****$2')
  } else { // 手机号
    // return preg_replace('/(1[358]{1}[0-9])[0-9]{4}([0-9]{4})/i','$1****$2',$phone)
    return $phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
  }
})

// 安全隐藏（显示前后4位）
Vue.filter('safeHidden', (val, safeHidden) => {
  if (safeHidden) {
    const reg = /^[0-9a-zA-Z]{4}([0-9a-zA-Z]*)[0-9a-zA-Z]{4}$/
    if (reg.test(val)) {
      // Array(RegExp.$1.length) 设置或返回数组中元素的数目。 然后去重
      val = val.replace(RegExp.$1, Array.from(Array(RegExp.$1.length), () => '*').join(''))
    }
    return val
  } else {
    return val
  }
})

// 获取字符串长度，中文为2个字符
Vue.prototype.getByteLen = (val) => {
  let len = 0
  for (let i = 0; i < val.length; i++) {
    let a = val.charAt(i)
    if (a.match(/[^\\x00-\\xff]/ig) != null) { // 中文
      len += 2
    } else {
      len += 1
    }
  }
  return len
}

// 过滤对象的空属性
Vue.prototype.removeEmptyProperty = (val) => {
  for (let prop in val) {
    if (!val[prop] && val[prop] !== 0) {
      delete val[prop]
    }
  }
  return val
}

// 判断两个数组里面的值是否相等
Vue.prototype.arrEqual = (arr1, arr2) => {
  const arrOne = arr1.sort()
  const arrTwo = arr2.sort()
  return arrOne.toString() === arrTwo.toString()
}
// 手机号码正则
Vue.prototype.phoneReg = /^1(3[0-9]|4[57]|5[0-35-9]|7[0135678]|8[0-9])\d{8}$/



// WEBPACK FOOTER //
// ./src/utils/filter.js